PopOver = require 'views/lib/pop-over'
View = require 'view'
template = require 'views/templates/member_large_avatar'
track = require 'debug/track'

module.exports = class LargeAvatarView extends View
  getViewTitle: -> @model.get('fullName')

  displayType: 'mod-avdetail'

  events:
    'click .js-profile': 'showProfile'

  render: ->
    data = @model.toJSON()

    @$el.html template(data)

    @

  showProfile: ->
    track("Mini Profile", "Large Avatar - Click Profile")
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member-menu-profile/large-avatar-view.coffee